
import { Eye } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';

interface EmailTemplatePreviewButtonProps {
  onClick: () => void;
  className?: string;
}

const EmailTemplatePreviewButton = ({ onClick, className }: EmailTemplatePreviewButtonProps) => {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      transition={{ type: "spring", stiffness: 400, damping: 10 }}
    >
      <Button
        onClick={onClick}
        variant="outline"
        className={cn(
          "code-button text-xs py-1 px-2 h-7 gap-1.5",
          className
        )}
      >
        <Eye className="h-3.5 w-3.5" />
        Template in Vorschau anzeigen
      </Button>
    </motion.div>
  );
};

export default EmailTemplatePreviewButton;
